"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteTenant = exports.updateTenant = exports.createTenant = exports.fetchTenant = exports.fetchTenants = exports.fetchAllTenants = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _reduxBatchedActions = require("redux-batched-actions");

var _actions = require("skybase-ui/skybase-core/base/actions");

var _rest = require("../rest");

var _actions2 = require("./actions");

var _constants = require("./constants");

var _actions3 = require("../actions");

var _constants2 = require("../constants");

var _utils = require("../utils");

var _tenantsI18n = require("./tenants-i18n");

var _messagesI18n = require("../messages-i18n");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var NORMAL = _constants2.STATES.NORMAL,
    LOADING = _constants2.STATES.LOADING;

var fetchAllTenants = function fetchAllTenants() {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      var _records$map, _yield$getTenantsApi, records, allTenants;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0, _rest.getTenantsApi)({
                pageSize: _constants.ALL_TENANTS_NUMBER,
                pageNumber: 1,
                structure: _constants.TENANT_STRUCTURES.FLAT
              });

            case 3:
              _yield$getTenantsApi = _context.sent;
              records = _yield$getTenantsApi.records;
              allTenants = (records === null || records === void 0 ? void 0 : (_records$map = records.map) === null || _records$map === void 0 ? void 0 : _records$map.call(records, function (_ref2) {
                var id = _ref2.id,
                    name = _ref2.name;
                return {
                  value: id,
                  label: name
                };
              })) || [];
              dispatch((0, _actions2.setAllTenants)(allTenants));
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              dispatch((0, _actions3.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _tenantsI18n.messages.errorDuringTenantsFetch
              }));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.fetchAllTenants = fetchAllTenants;

var fetchTenants = function fetchTenants(_ref3) {
  var pageSize = _ref3.pageSize,
      pageNumber = _ref3.pageNumber;
  var parentTenantId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch) {
      var _yield$getTenantsApi2, _yield$getTenantsApi3, tenants, listConfig;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              dispatch((0, _actions2.changeListTenantsState)(LOADING));
              _context2.next = 4;
              return (0, _rest.getTenantsApi)({
                pageSize: pageSize,
                pageNumber: pageNumber,
                parentTenantId: parentTenantId
              });

            case 4:
              _yield$getTenantsApi2 = _context2.sent;
              _yield$getTenantsApi3 = _yield$getTenantsApi2.records;
              tenants = _yield$getTenantsApi3 === void 0 ? [] : _yield$getTenantsApi3;
              listConfig = (0, _objectWithoutProperties2.default)(_yield$getTenantsApi2, ["records"]);
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions2.changeListTenantsState)(NORMAL), (0, _actions2.setTenants)(tenants), (0, _actions2.changeTenantListConfig)(listConfig)]));
              _context2.next = 16;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);
              dispatch((0, _actions2.changeListTenantsState)(NORMAL)); // todo handle errors

              console.log(_context2.t0);
              dispatch((0, _actions3.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _tenantsI18n.messages.errorDuringTenantsFetch
              }));

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 11]]);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.fetchTenants = fetchTenants;

var fetchTenant = function fetchTenant(tenantId) {
  var onError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch) {
      var tenant;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              dispatch((0, _actions2.changeUpdateTenantState)(LOADING));
              _context3.next = 4;
              return (0, _rest.getTenantApi)(tenantId);

            case 4:
              tenant = _context3.sent;
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions2.changeUpdateTenantState)(NORMAL), (0, _actions2.loadTenantToUpdate)(tenant)]));
              _context3.next = 14;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              dispatch((0, _actions2.changeUpdateTenantState)(NORMAL)); // todo handle errors

              console.log(_context3.t0);

              if (onError) {
                onError({
                  message: _tenantsI18n.messages.tenantWithIdDoesNotExist,
                  tenantId: tenantId
                });
              }

              dispatch((0, _actions3.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _tenantsI18n.messages.errorDuringTenantsFetch
              }));

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 8]]);
    }));

    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
};

exports.fetchTenant = fetchTenant;

var createTenant = function createTenant(tenant, _ref6) {
  var pageSize = _ref6.pageSize,
      pageNumber = _ref6.pageNumber;
  var parentTenantId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch) {
      var updatedTenant, errorCode;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              dispatch((0, _actions2.changeCreateTenantState)(LOADING));
              updatedTenant = _objectSpread(_objectSpread({}, tenant), parentTenantId ? {
                parentTenant: parentTenantId
              } : {});
              _context4.next = 5;
              return (0, _rest.createTenantApi)(updatedTenant);

            case 5:
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions2.changeCreateTenantState)(NORMAL), (0, _actions2.clearCreateTenantParams)(), (0, _actions.closeModal)()]));
              dispatch((0, _actions3.showSuccessToastFactory)({
                title: _messagesI18n.messages.success,
                message: _tenantsI18n.messages.tenantSuccessfullyCreated
              }));
              dispatch(fetchTenants({
                pageSize: pageSize,
                pageNumber: pageNumber
              }, parentTenantId));
              _context4.next = 20;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](0);
              dispatch((0, _actions2.changeCreateTenantState)(NORMAL));
              errorCode = (0, _utils.getErrorCode)(_context4.t0);
              _context4.t1 = errorCode;
              _context4.next = _context4.t1 === 409 ? 17 : 19;
              break;

            case 17:
              dispatch((0, _actions3.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _tenantsI18n.messages.tenantAlreadyExists
              }));
              return _context4.abrupt("break", 20);

            case 19:
              dispatch((0, _actions3.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _tenantsI18n.messages.errorDuringTenantCreation
              }));

            case 20:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 10]]);
    }));

    return function (_x4) {
      return _ref7.apply(this, arguments);
    };
  }();
};

exports.createTenant = createTenant;

var updateTenant = function updateTenant(tenant, _ref8) {
  var pageSize = _ref8.pageSize,
      pageNumber = _ref8.pageNumber;
  var parentTenantId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(dispatch) {
      var errorCode;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              dispatch((0, _actions2.changeUpdateTenantState)(LOADING));
              _context5.next = 4;
              return (0, _rest.updateTenantApi)(tenant);

            case 4:
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions2.changeUpdateTenantState)(NORMAL), (0, _actions.closeModal)()]));
              dispatch((0, _actions3.showSuccessToastFactory)({
                title: _messagesI18n.messages.success,
                message: _tenantsI18n.messages.tenantSuccessfullyUpdated
              }));
              dispatch(fetchTenants({
                pageSize: pageSize,
                pageNumber: pageNumber
              }, parentTenantId));
              _context5.next = 19;
              break;

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](0);
              dispatch((0, _actions2.changeUpdateTenantState)(NORMAL));
              errorCode = (0, _utils.getErrorCode)(_context5.t0);
              _context5.t1 = errorCode;
              _context5.next = _context5.t1 === 409 ? 16 : 18;
              break;

            case 16:
              dispatch((0, _actions3.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _tenantsI18n.messages.tenantAlreadyExists
              }));
              return _context5.abrupt("break", 19);

            case 18:
              dispatch((0, _actions3.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _tenantsI18n.messages.errorDuringTenantUpdate
              }));

            case 19:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 9]]);
    }));

    return function (_x5) {
      return _ref9.apply(this, arguments);
    };
  }();
};

exports.updateTenant = updateTenant;

var deleteTenant = function deleteTenant(id, _ref10) {
  var pageSize = _ref10.pageSize,
      pageNumber = _ref10.pageNumber;
  var parentTenantId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return /*#__PURE__*/function () {
    var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(dispatch) {
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return (0, _rest.deleteTenantApi)(id);

            case 3:
              dispatch((0, _actions2.clearAllTenantForms)());
              dispatch((0, _actions3.showSuccessToastFactory)({
                title: _messagesI18n.messages.success,
                message: _tenantsI18n.messages.tenantSuccessfullyDeleted
              }));
              dispatch(fetchTenants({
                pageSize: pageSize,
                pageNumber: pageNumber
              }, parentTenantId));
              _context6.next = 12;
              break;

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);
              // todo handle errors
              console.log(_context6.t0);
              dispatch((0, _actions3.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _tenantsI18n.messages.errorDuringTenantDeletion
              }));

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 8]]);
    }));

    return function (_x6) {
      return _ref11.apply(this, arguments);
    };
  }();
};

exports.deleteTenant = deleteTenant;
//# sourceMappingURL=utils.js.map